export interface Airport {
  code: string;
  name: string;
  city: string;
  state: string; // For US airports, or region/country for international
  country: string;
  lat: number;
  lng: number;
  timezone: string; // IANA timezone identifier
  utcOffset: number; // Standard UTC offset in hours (note: doesn't account for DST)
}

export const majorAirports: Airport[] = [
  // === UNITED STATES ===
  // California (Pacific Time - UTC-8)
  { code: "LAX", name: "Los Angeles International", city: "Los Angeles", state: "CA", country: "US", lat: 33.9416, lng: -118.4085, timezone: "America/Los_Angeles", utcOffset: -8 },
  { code: "SFO", name: "San Francisco International", city: "San Francisco", state: "CA", country: "US", lat: 37.6213, lng: -122.3790, timezone: "America/Los_Angeles", utcOffset: -8 },
  { code: "SAN", name: "San Diego International", city: "San Diego", state: "CA", country: "US", lat: 32.7338, lng: -117.1933, timezone: "America/Los_Angeles", utcOffset: -8 },
  { code: "SJC", name: "San Jose International", city: "San Jose", state: "CA", country: "US", lat: 37.3626, lng: -121.9291, timezone: "America/Los_Angeles", utcOffset: -8 },
  { code: "OAK", name: "Oakland International", city: "Oakland", state: "CA", country: "US", lat: 37.7213, lng: -122.2208, timezone: "America/Los_Angeles", utcOffset: -8 },
  
  // Texas (Central Time - UTC-6)
  { code: "DFW", name: "Dallas Fort Worth International", city: "Dallas", state: "TX", country: "US", lat: 32.8998, lng: -97.0403, timezone: "America/Chicago", utcOffset: -6 },
  { code: "IAH", name: "George Bush Intercontinental", city: "Houston", state: "TX", country: "US", lat: 29.9844, lng: -95.3414, timezone: "America/Chicago", utcOffset: -6 },
  { code: "AUS", name: "Austin-Bergstrom International", city: "Austin", state: "TX", country: "US", lat: 30.1945, lng: -97.6699, timezone: "America/Chicago", utcOffset: -6 },
  { code: "SAT", name: "San Antonio International", city: "San Antonio", state: "TX", country: "US", lat: 29.5337, lng: -98.4698, timezone: "America/Chicago", utcOffset: -6 },
  
  // New York/New Jersey (Eastern Time - UTC-5)
  { code: "JFK", name: "John F. Kennedy International", city: "New York", state: "NY", country: "US", lat: 40.6413, lng: -73.7781, timezone: "America/New_York", utcOffset: -5 },
  { code: "EWR", name: "Newark Liberty International", city: "Newark", state: "NJ", country: "US", lat: 40.6895, lng: -74.1745, timezone: "America/New_York", utcOffset: -5 },
  { code: "LGA", name: "LaGuardia Airport", city: "New York", state: "NY", country: "US", lat: 40.7769, lng: -73.8740, timezone: "America/New_York", utcOffset: -5 },
  
  // Pennsylvania (Eastern Time - UTC-5)
  { code: "PHL", name: "Philadelphia International", city: "Philadelphia", state: "PA", country: "US", lat: 39.8729, lng: -75.2437, timezone: "America/New_York", utcOffset: -5 },
  
  // Washington DC (Eastern Time - UTC-5)
  { code: "DCA", name: "Ronald Reagan Washington National", city: "Washington", state: "DC", country: "US", lat: 38.8521, lng: -77.0377, timezone: "America/New_York", utcOffset: -5 },
  { code: "IAD", name: "Washington Dulles International", city: "Washington", state: "VA", country: "US", lat: 38.9531, lng: -77.4565, timezone: "America/New_York", utcOffset: -5 },
  
  // Florida (Eastern Time - UTC-5)
  { code: "MIA", name: "Miami International", city: "Miami", state: "FL", country: "US", lat: 25.7959, lng: -80.2870, timezone: "America/New_York", utcOffset: -5 },
  { code: "MCO", name: "Orlando International", city: "Orlando", state: "FL", country: "US", lat: 28.4312, lng: -81.3081, timezone: "America/New_York", utcOffset: -5 },
  { code: "FLL", name: "Fort Lauderdale-Hollywood International", city: "Fort Lauderdale", state: "FL", country: "US", lat: 26.0742, lng: -80.1506, timezone: "America/New_York", utcOffset: -5 },
  { code: "TPA", name: "Tampa International", city: "Tampa", state: "FL", country: "US", lat: 27.9755, lng: -82.5332, timezone: "America/New_York", utcOffset: -5 },
  
  // Illinois (Central Time - UTC-6)
  { code: "ORD", name: "O'Hare International", city: "Chicago", state: "IL", country: "US", lat: 41.9742, lng: -87.9073, timezone: "America/Chicago", utcOffset: -6 },
  { code: "MDW", name: "Midway International", city: "Chicago", state: "IL", country: "US", lat: 41.7868, lng: -87.7522, timezone: "America/Chicago", utcOffset: -6 },
  
  // Ohio (Eastern Time - UTC-5)
  { code: "CLE", name: "Cleveland Hopkins International", city: "Cleveland", state: "OH", country: "US", lat: 41.4117, lng: -81.8498, timezone: "America/New_York", utcOffset: -5 },
  { code: "CMH", name: "John Glenn Columbus International", city: "Columbus", state: "OH", country: "US", lat: 39.9980, lng: -82.8919, timezone: "America/New_York", utcOffset: -5 },
  
  // Michigan (Eastern Time - UTC-5)
  { code: "DTW", name: "Detroit Metropolitan Wayne County", city: "Detroit", state: "MI", country: "US", lat: 42.2162, lng: -83.3554, timezone: "America/Detroit", utcOffset: -5 },
  
  // Georgia (Eastern Time - UTC-5)
  { code: "ATL", name: "Hartsfield-Jackson Atlanta International", city: "Atlanta", state: "GA", country: "US", lat: 33.6407, lng: -84.4277, timezone: "America/New_York", utcOffset: -5 },
  
  // Nevada (Pacific Time - UTC-8)
  { code: "LAS", name: "Harry Reid International", city: "Las Vegas", state: "NV", country: "US", lat: 36.0840, lng: -115.1537, timezone: "America/Los_Angeles", utcOffset: -8 },
  
  // Arizona (Mountain Standard - UTC-7, no DST)
  { code: "PHX", name: "Phoenix Sky Harbor International", city: "Phoenix", state: "AZ", country: "US", lat: 33.4373, lng: -112.0078, timezone: "America/Phoenix", utcOffset: -7 },
  
  // Colorado (Mountain Time - UTC-7)
  { code: "DEN", name: "Denver International", city: "Denver", state: "CO", country: "US", lat: 39.8561, lng: -104.6737, timezone: "America/Denver", utcOffset: -7 },
  
  // Washington State (Pacific Time - UTC-8)
  { code: "SEA", name: "Seattle-Tacoma International", city: "Seattle", state: "WA", country: "US", lat: 47.4502, lng: -122.3088, timezone: "America/Los_Angeles", utcOffset: -8 },
  
  // Massachusetts (Eastern Time - UTC-5)
  { code: "BOS", name: "Boston Logan International", city: "Boston", state: "MA", country: "US", lat: 42.3656, lng: -71.0096, timezone: "America/New_York", utcOffset: -5 },
  
  // Minnesota (Central Time - UTC-6)
  { code: "MSP", name: "Minneapolis-Saint Paul International", city: "Minneapolis", state: "MN", country: "US", lat: 44.8848, lng: -93.2223, timezone: "America/Chicago", utcOffset: -6 },
  
  // === UNITED ARAB EMIRATES (Gulf Standard Time - UTC+4) ===
  { code: "DXB", name: "Dubai International", city: "Dubai", state: "Dubai", country: "AE", lat: 25.2532, lng: 55.3657, timezone: "Asia/Dubai", utcOffset: 4 },
  { code: "AUH", name: "Abu Dhabi International", city: "Abu Dhabi", state: "Abu Dhabi", country: "AE", lat: 24.4330, lng: 54.6511, timezone: "Asia/Dubai", utcOffset: 4 },
  { code: "DWC", name: "Al Maktoum International", city: "Dubai", state: "Dubai", country: "AE", lat: 24.8962, lng: 55.1614, timezone: "Asia/Dubai", utcOffset: 4 },
  { code: "SHJ", name: "Sharjah International", city: "Sharjah", state: "Sharjah", country: "AE", lat: 25.3286, lng: 55.5172, timezone: "Asia/Dubai", utcOffset: 4 },
  
  // === INDIA (India Standard Time - UTC+5:30) ===
  { code: "DEL", name: "Indira Gandhi International", city: "New Delhi", state: "Delhi", country: "IN", lat: 28.5562, lng: 77.1000, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "BOM", name: "Chhatrapati Shivaji Maharaj International", city: "Mumbai", state: "Maharashtra", country: "IN", lat: 19.0896, lng: 72.8656, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "BLR", name: "Kempegowda International", city: "Bengaluru", state: "Karnataka", country: "IN", lat: 13.1986, lng: 77.7066, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "HYD", name: "Rajiv Gandhi International", city: "Hyderabad", state: "Telangana", country: "IN", lat: 17.2403, lng: 78.4294, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "MAA", name: "Chennai International", city: "Chennai", state: "Tamil Nadu", country: "IN", lat: 12.9941, lng: 80.1709, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "CCU", name: "Netaji Subhas Chandra Bose International", city: "Kolkata", state: "West Bengal", country: "IN", lat: 22.6520, lng: 88.4463, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "AMD", name: "Sardar Vallabhbhai Patel International", city: "Ahmedabad", state: "Gujarat", country: "IN", lat: 23.0772, lng: 72.6347, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "COK", name: "Cochin International", city: "Kochi", state: "Kerala", country: "IN", lat: 10.1520, lng: 76.4019, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "PNQ", name: "Pune International", city: "Pune", state: "Maharashtra", country: "IN", lat: 18.5822, lng: 73.9197, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  { code: "JAI", name: "Jaipur International", city: "Jaipur", state: "Rajasthan", country: "IN", lat: 26.8242, lng: 75.8122, timezone: "Asia/Kolkata", utcOffset: 5.5 },
  
  // === UNITED KINGDOM (GMT/BST - UTC+0/+1) ===
  { code: "LHR", name: "London Heathrow", city: "London", state: "England", country: "GB", lat: 51.4700, lng: -0.4543, timezone: "Europe/London", utcOffset: 0 },
  { code: "LGW", name: "London Gatwick", city: "London", state: "England", country: "GB", lat: 51.1537, lng: -0.1821, timezone: "Europe/London", utcOffset: 0 },
  { code: "MAN", name: "Manchester Airport", city: "Manchester", state: "England", country: "GB", lat: 53.3537, lng: -2.2750, timezone: "Europe/London", utcOffset: 0 },
  { code: "BHX", name: "Birmingham Airport", city: "Birmingham", state: "England", country: "GB", lat: 52.4539, lng: -1.7480, timezone: "Europe/London", utcOffset: 0 },
  
  // === CANADA ===
  { code: "YYZ", name: "Toronto Pearson International", city: "Toronto", state: "Ontario", country: "CA", lat: 43.6777, lng: -79.6248, timezone: "America/Toronto", utcOffset: -5 },
  { code: "YVR", name: "Vancouver International", city: "Vancouver", state: "British Columbia", country: "CA", lat: 49.1967, lng: -123.1815, timezone: "America/Vancouver", utcOffset: -8 },
  { code: "YUL", name: "Montréal-Trudeau International", city: "Montreal", state: "Quebec", country: "CA", lat: 45.4706, lng: -73.7408, timezone: "America/Montreal", utcOffset: -5 },
  { code: "YYC", name: "Calgary International", city: "Calgary", state: "Alberta", country: "CA", lat: 51.1215, lng: -114.0076, timezone: "America/Edmonton", utcOffset: -7 },
  
  // === MEXICO (Central Time - UTC-6) ===
  { code: "MEX", name: "Mexico City International", city: "Mexico City", state: "CDMX", country: "MX", lat: 19.4363, lng: -99.0721, timezone: "America/Mexico_City", utcOffset: -6 },
  { code: "CUN", name: "Cancún International", city: "Cancún", state: "Quintana Roo", country: "MX", lat: 21.0365, lng: -86.8771, timezone: "America/Cancun", utcOffset: -5 },
  { code: "GDL", name: "Guadalajara International", city: "Guadalajara", state: "Jalisco", country: "MX", lat: 20.5218, lng: -103.3111, timezone: "America/Mexico_City", utcOffset: -6 },
  { code: "SJD", name: "Los Cabos International", city: "San José del Cabo", state: "Baja California Sur", country: "MX", lat: 23.1518, lng: -109.7215, timezone: "America/Mazatlan", utcOffset: -7 },
  
  // === CARIBBEAN ===
  { code: "SJU", name: "Luis Muñoz Marín International", city: "San Juan", state: "Puerto Rico", country: "PR", lat: 18.4394, lng: -66.0018, timezone: "America/Puerto_Rico", utcOffset: -4 },
  { code: "NAS", name: "Lynden Pindling International", city: "Nassau", state: "New Providence", country: "BS", lat: 25.0390, lng: -77.4662, timezone: "America/Nassau", utcOffset: -5 },
  { code: "MBJ", name: "Sangster International", city: "Montego Bay", state: "Jamaica", country: "JM", lat: 18.5037, lng: -77.9134, timezone: "America/Jamaica", utcOffset: -5 },
  
  // === EUROPE ===
  { code: "CDG", name: "Paris Charles de Gaulle", city: "Paris", state: "Île-de-France", country: "FR", lat: 49.0097, lng: 2.5479, timezone: "Europe/Paris", utcOffset: 1 },
  { code: "FRA", name: "Frankfurt Airport", city: "Frankfurt", state: "Hesse", country: "DE", lat: 50.0379, lng: 8.5622, timezone: "Europe/Berlin", utcOffset: 1 },
  { code: "AMS", name: "Amsterdam Schiphol", city: "Amsterdam", state: "North Holland", country: "NL", lat: 52.3105, lng: 4.7683, timezone: "Europe/Amsterdam", utcOffset: 1 },
  { code: "FCO", name: "Rome Fiumicino", city: "Rome", state: "Lazio", country: "IT", lat: 41.8003, lng: 12.2389, timezone: "Europe/Rome", utcOffset: 1 },
  { code: "MAD", name: "Madrid Barajas", city: "Madrid", state: "Community of Madrid", country: "ES", lat: 40.4983, lng: -3.5676, timezone: "Europe/Madrid", utcOffset: 1 },
  { code: "BCN", name: "Barcelona El Prat", city: "Barcelona", state: "Catalonia", country: "ES", lat: 41.2974, lng: 2.0833, timezone: "Europe/Madrid", utcOffset: 1 },
  
  // === ASIA-PACIFIC ===
  { code: "SIN", name: "Singapore Changi", city: "Singapore", state: "Singapore", country: "SG", lat: 1.3644, lng: 103.9915, timezone: "Asia/Singapore", utcOffset: 8 },
  { code: "HKG", name: "Hong Kong International", city: "Hong Kong", state: "Hong Kong", country: "HK", lat: 22.3080, lng: 113.9185, timezone: "Asia/Hong_Kong", utcOffset: 8 },
  { code: "BKK", name: "Suvarnabhumi Airport", city: "Bangkok", state: "Samut Prakan", country: "TH", lat: 13.6900, lng: 100.7501, timezone: "Asia/Bangkok", utcOffset: 7 },
  { code: "NRT", name: "Narita International", city: "Tokyo", state: "Chiba", country: "JP", lat: 35.7720, lng: 140.3929, timezone: "Asia/Tokyo", utcOffset: 9 },
  { code: "ICN", name: "Incheon International", city: "Seoul", state: "Incheon", country: "KR", lat: 37.4602, lng: 126.4407, timezone: "Asia/Seoul", utcOffset: 9 },
  { code: "SYD", name: "Sydney Kingsford Smith", city: "Sydney", state: "New South Wales", country: "AU", lat: -33.9399, lng: 151.1753, timezone: "Australia/Sydney", utcOffset: 11 },
  
  // === MIDDLE EAST ===
  { code: "DOH", name: "Hamad International", city: "Doha", state: "Qatar", country: "QA", lat: 25.2609, lng: 51.6138, timezone: "Asia/Qatar", utcOffset: 3 },
  { code: "RUH", name: "King Khalid International", city: "Riyadh", state: "Riyadh", country: "SA", lat: 24.9576, lng: 46.6988, timezone: "Asia/Riyadh", utcOffset: 3 },
  { code: "JED", name: "King Abdulaziz International", city: "Jeddah", state: "Makkah", country: "SA", lat: 21.6796, lng: 39.1565, timezone: "Asia/Riyadh", utcOffset: 3 },
  { code: "BAH", name: "Bahrain International", city: "Manama", state: "Bahrain", country: "BH", lat: 26.2708, lng: 50.6336, timezone: "Asia/Bahrain", utcOffset: 3 },
  { code: "KWI", name: "Kuwait International", city: "Kuwait City", state: "Kuwait", country: "KW", lat: 29.2266, lng: 47.9689, timezone: "Asia/Kuwait", utcOffset: 3 },
  { code: "MCT", name: "Muscat International", city: "Muscat", state: "Muscat", country: "OM", lat: 23.5933, lng: 58.2844, timezone: "Asia/Muscat", utcOffset: 4 },
  
  // === AFRICA ===
  { code: "JNB", name: "O.R. Tambo International", city: "Johannesburg", state: "Gauteng", country: "ZA", lat: -26.1392, lng: 28.2460, timezone: "Africa/Johannesburg", utcOffset: 2 },
  { code: "CPT", name: "Cape Town International", city: "Cape Town", state: "Western Cape", country: "ZA", lat: -33.9715, lng: 18.6021, timezone: "Africa/Johannesburg", utcOffset: 2 },
  { code: "CAI", name: "Cairo International", city: "Cairo", state: "Cairo", country: "EG", lat: 30.1219, lng: 31.4056, timezone: "Africa/Cairo", utcOffset: 2 },
  { code: "NBO", name: "Jomo Kenyatta International", city: "Nairobi", state: "Nairobi", country: "KE", lat: -1.3192, lng: 36.9278, timezone: "Africa/Nairobi", utcOffset: 3 },
];

// Haversine formula to calculate distance between two points
export function calculateDistance(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const R = 3959; // Earth's radius in miles
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;
  
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  
  return Math.round(distance);
}

export function findNearestAirport(venueLat: number, venueLng: number): {
  airport: Airport;
  distance: number;
} {
  let nearest = majorAirports[0];
  let minDistance = calculateDistance(venueLat, venueLng, nearest.lat, nearest.lng);
  
  for (const airport of majorAirports) {
    const distance = calculateDistance(venueLat, venueLng, airport.lat, airport.lng);
    if (distance < minDistance) {
      minDistance = distance;
      nearest = airport;
    }
  }
  
  return { airport: nearest, distance: minDistance };
}

// Helper to format airport location display
export function formatAirportLocation(airport: Airport): string {
  if (airport.country === 'US') {
    return `${airport.city}, ${airport.state}`;
  }
  return `${airport.city}, ${airport.state}`;
}

export function calculateTravelSurcharge(distanceInMiles: number): number {
  // Base travel fee included in pricing up to 50 miles
  if (distanceInMiles <= 50) return 0;
  
  // $100 per 50 miles beyond the first 50
  const extraMiles = distanceInMiles - 50;
  const surcharge = Math.ceil(extraMiles / 50) * 100;
  
  return surcharge;
}

/**
 * Get the UTC offset difference in hours between two airports.
 * Positive means destination is ahead of origin.
 * E.g., DFW (-6) to AUH (+4) = +10 hours
 */
export function getTimezoneOffsetHours(originCode: string, destCode: string): number {
  const origin = majorAirports.find(a => a.code === originCode);
  const dest = majorAirports.find(a => a.code === destCode);
  if (!origin || !dest) return 0;
  return dest.utcOffset - origin.utcOffset;
}

/**
 * Get timezone abbreviation for display (e.g., "CT", "PT", "GST")
 */
export function getAirportTimezoneAbbr(code: string): string {
  const airport = majorAirports.find(a => a.code === code);
  if (!airport) return '';
  
  // Map IANA timezones to abbreviations
  const tzMap: Record<string, string> = {
    'America/New_York': 'ET',
    'America/Chicago': 'CT',
    'America/Denver': 'MT',
    'America/Phoenix': 'MT',
    'America/Los_Angeles': 'PT',
    'America/Toronto': 'ET',
    'America/Vancouver': 'PT',
    'America/Montreal': 'ET',
    'America/Edmonton': 'MT',
    'America/Detroit': 'ET',
    'America/Mexico_City': 'CT',
    'America/Cancun': 'ET',
    'America/Mazatlan': 'MT',
    'America/Puerto_Rico': 'AT',
    'America/Nassau': 'ET',
    'America/Jamaica': 'ET',
    'Europe/London': 'GMT',
    'Europe/Paris': 'CET',
    'Europe/Berlin': 'CET',
    'Europe/Amsterdam': 'CET',
    'Europe/Rome': 'CET',
    'Europe/Madrid': 'CET',
    'Asia/Dubai': 'GST',
    'Asia/Kolkata': 'IST',
    'Asia/Singapore': 'SGT',
    'Asia/Hong_Kong': 'HKT',
    'Asia/Bangkok': 'ICT',
    'Asia/Tokyo': 'JST',
    'Asia/Seoul': 'KST',
    'Asia/Qatar': 'AST',
    'Asia/Riyadh': 'AST',
    'Asia/Bahrain': 'AST',
    'Asia/Kuwait': 'AST',
    'Asia/Muscat': 'GST',
    'Australia/Sydney': 'AEDT',
    'Africa/Johannesburg': 'SAST',
    'Africa/Cairo': 'EET',
    'Africa/Nairobi': 'EAT',
  };
  
  return tzMap[airport.timezone] || `UTC${airport.utcOffset >= 0 ? '+' : ''}${airport.utcOffset}`;
}

/**
 * Get the airport object by code
 */
export function getAirport(code: string): Airport | undefined {
  return majorAirports.find(a => a.code === code);
}
